import React, { useState } from "react";
import { Box, Typography, Button, CircularProgress, Alert, Chip, Tooltip, IconButton } from "@mui/material";
import { Globe, RefreshCw, ExternalLink, Copy, Check } from "lucide-react";
import { useTranslation } from "react-i18next";
const PreviewTab = ({
  settings,
  onTogglePublish,
  saving
}) => {
  const {
    t
  } = useTranslation("website");
  const [key, setKey] = useState(0);
  const [copied, setCopied] = useState(false);
  const FRONTEND_BASE = (process.env.REACT_APP_URL || window.location.origin).replace(/\/$/, "");
  const siteUrl = settings?.slug ? `${FRONTEND_BASE}/w/${settings.slug}` : null;
  const previewUrl = siteUrl ? `${siteUrl}?preview=1` : null;
  const copyLink = () => {
    if (!siteUrl) return;
    navigator.clipboard.writeText(siteUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <Box>
      {/* Status bar */}
      <Box sx={{
      display: "flex",
      alignItems: "center",
      gap: 2,
      mb: 2,
      flexWrap: "wrap"
    }}>
        <Chip label={settings?.isPublished ? "Live" : "Offline"} color={settings?.isPublished ? "success" : "default"} icon={<Globe size={14} />} />
        
        {siteUrl && <Typography variant="body2" color="text.secondary" sx={{
        fontFamily: "monospace"
      }}>
            {siteUrl}
          </Typography>}
        <Box sx={{
        display: "flex",
        gap: 1,
        ml: "auto"
      }}>
          {siteUrl && <>
              <Tooltip title={copied ? "Copied!" : "Copy link"}>
                <IconButton size="small" onClick={copyLink}>
                  {copied ? <Check size={16} color="#4caf50" /> : <Copy size={16} />}
                </IconButton>
              </Tooltip>
              <Tooltip title={t("Open in new tab")}>
                <IconButton size="small" component="a" href={previewUrl} target="_blank">
                  <ExternalLink size={16} />
                </IconButton>
              </Tooltip>
            </>}
          <Tooltip title={t("Refresh preview")}>
            <IconButton size="small" onClick={() => setKey(k => k + 1)}>
              <RefreshCw size={16} />
            </IconButton>
          </Tooltip>
          <Button variant={settings?.isPublished ? "outlined" : "contained"} color={settings?.isPublished ? "warning" : "success"} size="small" onClick={onTogglePublish} disabled={saving} startIcon={saving ? <CircularProgress size={14} /> : <Globe size={14} />}>
            
            {settings?.isPublished ? t("Take Offline") : t("Publish")}
          </Button>
        </Box>
      </Box>

      {!settings?.slug && <Alert severity="warning" sx={{
      mb: 2
    }}>{t("Set a URL slug in the General tab before you can preview your site.")}

      </Alert>}

      {!settings?.isPublished && settings?.slug && <Alert severity="info" sx={{
      mb: 2
    }}>{t("Your site is offline. Publish it to make it visible to visitors.")}

      </Alert>}

      {previewUrl ? <Box sx={{
      border: "2px solid",
      borderColor: "divider",
      borderRadius: 2,
      overflow: "hidden",
      height: "70vh",
      bgcolor: "#f5f5f5"
    }}>
        
          <iframe key={key} src={previewUrl} title={t("Website Preview")} style={{
        width: "100%",
        height: "100%",
        border: "none",
        display: "block"
      }} sandbox="allow-scripts allow-same-origin allow-forms allow-popups" />
        
        </Box> : <Box sx={{
      height: "40vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      bgcolor: "grey.50",
      borderRadius: 2,
      border: "2px dashed",
      borderColor: "divider"
    }}>
          <Box sx={{
        textAlign: "center",
        color: "text.secondary"
      }}>
            <Globe size={48} style={{
          opacity: 0.3,
          marginBottom: 12
        }} />
            <Typography>{t("Set a slug in General settings to preview your site")}</Typography>
          </Box>
        </Box>}
    </Box>;
};
export default PreviewTab;
